import { Capacitor } from "@capacitor/core";

let Haptics: any = null;
let ImpactStyle: any = null;

// Lazy load Capacitor Haptics — only on native platforms
if (Capacitor.isNativePlatform()) {
  import("@capacitor/haptics").then((mod) => {
    Haptics = mod.Haptics;
    ImpactStyle = mod.ImpactStyle;
  }).catch(() => {});
}

export const hapticLight = () => {
  if (Haptics && ImpactStyle) {
    Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
  }
};

export const hapticMedium = () => {
  if (Haptics && ImpactStyle) {
    Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {});
  }
};

export const hapticHeavy = () => {
  if (Haptics && ImpactStyle) {
    Haptics.impact({ style: ImpactStyle.Heavy }).catch(() => {});
  }
};
